
import {Component, Vue} from 'vue-property-decorator';
import AcompanhamentoComponent from "../../components/AcompanhamentoComponent.vue";

@Component({
  name: "Acompanhamento",
  components: {AcompanhamentoComponent}
})
export default class Acompanhamento extends Vue {
}
